import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const addCustomMeasurementEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_CUSTOM_MEASUREMENT();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error posting custom measurement data: ${error.message}`);
  }
};

export const updateCustomMeasurementEndpoint = async (data, measurementId) => {
  const endpoint = API_ENDPOINTS.UPDATE_CUSTOM_MEASUREMENT(measurementId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating custom measurement: ${error.message}`);
  }
};

export const deleteCustomMeasurementEndpoint = async measurementId => {
  const endpoint = API_ENDPOINTS.DELETE_CUSTOM_MEASUREMENT(measurementId);
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error) {
    throw new Error(`Error deleting custom measurement: ${error.message}`);
  }
};
